import { KNOWN_TIER_KEYS } from '@tempo-io/loop-entitlements';
import { z } from 'zod';

export const loopEntitlementDTOSchema = z.object({
  renewalDate: z.string().nullable(),
  platformIncluded: z.boolean(),
  connectedSystemUserCount: z.number().nullable(),
  tier: z.enum(KNOWN_TIER_KEYS).nullable(),
  aiCreditAllocation: z.number().nullable(),
  integrationsCount: z.number().nullable(),
  modules: z.object({
    visibility: z.boolean(),
    strategy: z.boolean(),
    planning: z.boolean(),
  }),
});

export type LoopEntitlementDTO = z.infer<typeof loopEntitlementDTOSchema>;

export const organizationEntitlementsDTOSchema = z.object({
  loop: loopEntitlementDTOSchema.nullable(),
});

export type OrganizationEntitlementsDTO = z.infer<typeof organizationEntitlementsDTOSchema>;
